import { Text } from '~/components/ui/text';
import { CustomFieldProps } from '~/interfaces/CustomFieldProps';

const TitleField = ({ field }: CustomFieldProps) => (
  <Text className='mb-4 font-medium' level='title-lg'>
    {field.fieldTitle}
  </Text>
);

export default TitleField;
